import * as React from "react";
import type { SVGProps } from "react";

const FacilityCafe = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M5.83073 2.5V5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.7487 2.5V5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 2.5V5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1654 14.1667H15.832C17.2127 14.1667 18.332 13.0474 18.332 11.6667V9.58333C18.332 8.43274 17.3993 7.5 16.2487 7.5H13.332"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2474 17.5H5.41406C3.80323 17.5 2.4974 16.1942 2.4974 14.5833L2.4974 8.33333C2.4974 7.8731 2.87049 7.5 3.33073 7.5L13.3307 7.5C13.791 7.5 14.1641 7.8731 14.1641 8.33333L14.1641 14.5833C14.1641 16.1942 12.8582 17.5 11.2474 17.5Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityCafe.displayName = "FacilityCafe";

export default FacilityCafe;
